<section
  id="navbar"
  [ngClass]="isTransparent ? 'navigation-transparent' : 'navigation-wrap'"
>
  <div class="navigation-container">
    <img
      src="assets/icons/mzm_homes_logo_white.svg"
      alt="MZM Homes Logo"
      style="cursor: pointer"
      routerLink="/"
    />
    <div class="links">
      <div class="home-selector">
        <a routerLink="/homes" routerLinkActive="active" class="home-link">{{
          translate("nav.mobileHomes")
        }}</a>
        <div
          class="home-dropdown"
          *ngIf="!homesLoading && homeModels.length > 0"
        >
          <div class="home-models">
            <div *ngFor="let home of homeModels" class="home-option">
              <a [routerLink]="'/homes/' + home.slug">{{
                translate(home.name)
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="product-selector">
        <a
          routerLink="/products"
          routerLinkActive="active"
          class="product-link"
          >{{ translate("nav.products") }}</a
        >
        <div
          class="product-dropdown"
          *ngIf="!productsLoading && productCategories.length > 0"
        >
          <div
            *ngFor="let category of productCategories"
            class="product-category"
          >
            <div class="category-header">
              <a
                href="#"
                (click)="navigateToCategory(category, $event)"
                class="category-name"
                >{{ translate(category.name) }}</a
              >
            </div>
            <!-- Products removed as per requirement to show only categories -->
          </div>
        </div>
      </div>
      <a routerLink="/about" routerLinkActive="active">{{
        translate("nav.about")
      }}</a>
      <a routerLink="/contact" routerLinkActive="active">{{
        translate("nav.contact")
      }}</a>
      <!-- <a routerLink="/blog" routerLinkActive="active">{{
        translate("nav.blog")
      }}</a> -->

      <div class="language-selector">
        <div class="selected-language">{{ currentLanguage.toUpperCase() }}</div>
        <div class="language-dropdown">
          <div
            *ngFor="let lang of languages"
            class="language-option"
            [class.active]="lang.code === currentLanguage"
            (click)="setLanguage(lang.code)"
          >
            {{ lang.name }}
          </div>
        </div>
      </div>

      <button (click)="openEnquiryModal()">
        {{ translate("nav.enquire") }}
      </button>

      <img
        src="assets/icons/open-hamburger.svg"
        alt="{{ translate('nav.openMenu') }}"
        *ngIf="!isMobileMenuOpen"
        (click)="toggleMobileMenu()"
        class="hamburger-icon"
      />
      <img
        src="assets/icons/close-hamburger.svg"
        alt="{{ translate('nav.closeMenu') }}"
        *ngIf="isMobileMenuOpen"
        (click)="toggleMobileMenu()"
        class="hamburger-icon"
      />
    </div>
  </div>

  <div class="nav-divider"></div>
</section>

<!-- Mobile Menu -->
<section class="mobile-menu" [class.open]="isMobileMenuOpen">
  <div class="container">
    <div class="top"></div>
    <div class="middle">
      <a routerLink="/" (click)="toggleMobileMenu()">{{
        translate("nav.home")
      }}</a>
      <a routerLink="/homes" (click)="toggleMobileMenu()">{{
        translate("nav.mobileHomes")
      }}</a>
      <a routerLink="/products" (click)="toggleMobileMenu()">{{
        translate("nav.products")
      }}</a>
      <!-- Mobile Product Categories -->
      <div
        class="mobile-product-categories"
        *ngIf="!productsLoading && productCategories.length > 0"
      >
        <a
          *ngFor="let category of productCategories"
          href="#"
          (click)="navigateToCategory(category, $event); toggleMobileMenu()"
          class="mobile-category-link"
        >
          {{ translate(category.name) }}
        </a>
      </div>
      <a routerLink="/about" (click)="toggleMobileMenu()">{{
        translate("nav.about")
      }}</a>
      <a routerLink="/blog" (click)="toggleMobileMenu()">{{
        translate("nav.blog")
      }}</a>
      <a routerLink="/contact" (click)="toggleMobileMenu()">{{
        translate("nav.contact")
      }}</a>

      <div class="mobile-language-selector">
        <div
          *ngFor="let lang of languages"
          class="mobile-language-option"
          [class.active]="lang.code === currentLanguage"
          (click)="setLanguage(lang.code); toggleMobileMenu()"
        >
          {{ lang.name }}
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="divider"></div>
      <div class="social-links">
        <a href="#" target="_blank">
          <img
            src="assets/icons/instagram_icon.svg"
            alt="{{ translate('footer.social.instagram') }}"
          />
        </a>
        <a href="#" target="_blank">
          <img
            src="assets/icons/linkedin_icon.svg"
            alt="{{ translate('footer.social.linkedin') }}"
          />
        </a>
        <a href="#" target="_blank">
          <img
            src="assets/icons/facebook_icon.svg"
            alt="{{ translate('footer.social.facebook') }}"
          />
        </a>
      </div>
    </div>
  </div>
</section>

<!-- POPUP BLUR ONE -->
<div class="modal-blur"></div>

<!-- CONTACT FORM MODAL -->
<div class="modal-container">
  <img src="assets/icons/close-modal.svg" id="close-contact-modal" alt="" />

  <h3>{{ translate("enquiry.formTitle") }}</h3>
  <p>{{ translate("enquiry.generalEnquiry") }}</p>
  <p>{{ translate("enquiry.specificProduct") }}</p>

  <app-enquiry-form></app-enquiry-form>
</div>
